import React from 'react'
import { SiteSettingsContext, defaultSettings } from './site-settings-context-types'

export const SiteSettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Using hardcoded settings instead of fetching from Sanity
  const value = {
    settings: defaultSettings,
    loading: false,
    error: null
  }

  return (
    <SiteSettingsContext.Provider value={value}>
      {children}
    </SiteSettingsContext.Provider>
  )
}